import React from 'react';
import I18n from 'i18n-js';
import { compact } from 'lodash';
import { gql } from '@reverbdotcom/commons/src/gql';
import ModalDialog from '@reverbdotcom/commons/src/components/modal_dialog';
import { CoreMyListingAvailableSalesMemberships } from '@reverbdotcom/commons/src/gql/graphql';

import SalesMemberships from './SalesMemberships';

export const AvailableSalesMembershipsFragment = gql(`
  fragment AvailableSalesMemberships on Listing {
    _id
    availableSalesMemberships {
      reverbSalesMemberships {
        listingId
        sale {
          _id
          id
          name
          percent
          startsAt {
            seconds
          }
          endsAt {
            seconds
          }
          links {
            self {
              href
            }
          }
        }
        totalLiveListings
        isListingInSale
        isListingEligible
      }
      sellerSalesMemberships {
        listingId
        sale {
          _id
          id
          name
          percent
          startsAt {
            seconds
          }
          endsAt {
            seconds
          }
          links {
            self {
              href
            }
          }
        }
        totalLiveListings
        isListingInSale
        isListingEligible
      }
    }
  }
`);

export const AVAILABLE_SALES_MEMBERSHIPS_QUERY = gql(`
  query Core_MyListing_AvailableSalesMemberships($listingId: String) {
    listing(input: { id: $listingId }) {
      _id
      id
      ...AvailableSalesMemberships
    }
  },
`);

interface IExternalProps {
  data: CoreMyListingAvailableSalesMemberships.Query;
  isModalOpen: boolean;
  onModalClose: () => void;
}

export function SalesModal({
  data,
  isModalOpen,
  onModalClose,
}: IExternalProps) {

  const availableSalesMemberships = data?.listing?.availableSalesMemberships;
  const reverbSalesMemberships = compact(availableSalesMemberships?.reverbSalesMemberships);
  const sellerSalesMemberships = compact(availableSalesMemberships?.sellerSalesMemberships);

  return (
    <ModalDialog
      isOpen={isModalOpen}
      headerTitle={I18n.t('discovery.listingsManagement.sellerListingCard.sales.modal.title')}
      onSubmit={() => onModalClose()}
      onRequestClose={() => onModalClose()}
      saveButtonText={I18n.t('discovery.listingsManagement.sellerListingCard.sales.modal.closeButtonText')}
      hideFooterDismissButton
    >
      <SalesMemberships
        defaultReverbSalesMemberships={reverbSalesMemberships}
        defaultSellerSalesMemberships={sellerSalesMemberships}
      />
    </ModalDialog>
  );
}

export default SalesModal;
